export default __webpack_public_path__ + "static/media/R1.e1e766da.png";